export const app = {
  connectToYourWhatsappNumber: 'Conectați-vă la numărul dvs. WhatsApp',
  connectYourWhatsappBotWithYourWhatsappNumber: 'Conectați botul WhatsApp la numărul dvs. WhatsApp',
  connect: 'Conectează',
};
